import { Button, BUTTON_SIZE, BUTTON_TYPES } from '@src/quince-components/src'
import classnames from 'classnames'
import { TFunction, useTranslation } from 'next-i18next'
import React from 'react'

import { OptionProp } from '../OptionSelector.constant'

import styles from './packOption.module.scss'

type PackOptionProps = {
  value: string
  quantityInPack?: number
} & Pick<OptionProp, 'isSelected' | 'salePrice' | 'className'>

const PackOption = ({ value, quantityInPack, isSelected, className, salePrice }: PackOptionProps) => {
  const { t } = useTranslation('common')
  return (
    <Button
      type={BUTTON_TYPES.OUTLINED}
      size={BUTTON_SIZE.MEDIUM}
      disabled={false}
      round={false}
      className={classnames(styles.option, isSelected && styles.selected_option)}
    >
      {renderButtonValue(value, salePrice, quantityInPack, t)}
    </Button>
  )
}

const renderButtonValue = (value: string, salePrice: number | undefined, quantityInPack?: number, t: TFunction) => {
  const salePriceValue = salePrice && (Math.round(salePrice * 100) / 100).toFixed(2)
  const priceForEachItem = salePriceValue && quantityInPack && (parseFloat(salePriceValue) / quantityInPack).toFixed(2)

  return (
    <>
      <span>
        {value} {salePriceValue && `$${salePriceValue}`}
      </span>
      {priceForEachItem && <span className={styles.itemPrice}>{t('var1_ea', { var1: priceForEachItem })}</span>}
    </>
  )
}

export default PackOption
